import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { css } from '@emotion/react';

import { setPopover } from '../actions/login';
import { readLocalTokens } from '../actions/tokens';
import theme from '../constants/theme';
import { useUserTracking } from '../helpers/tracking';
import AccountMenu from './AccountMenu';
import UpgradesBubble from './UpgradesBubble';
import { useOnClickOutside } from './useOnClickOutside';

const AccountButton = () => {
  const ref = useRef();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.login.isLoggedIn);
  const showPopover = useSelector((state) => state.login.showPopover);

  useOnClickOutside(ref, () => dispatch(setPopover(false)));

  useUserTracking();

  useEffect(() => {
    dispatch(readLocalTokens());
  }, [dispatch]);

  return (
    <span ref={ref}>
      <button
        data-testid="account-icon"
        css={css`
          outline: none;
          position: relative;
          display: inline-block;
          background: none;
          border: none;
          padding: 10px 15px;
          position: relative;
          line-height: 1.5;
          svg {
            fill: ${isLoggedIn
              ? theme.colors.primaryBlue
              : theme.colors.textStandard};
          }
          .account-upgrades-bubble {
            top: 4px;
            position: absolute;
          }
          :disabled svg {
            fill: ${theme.colors.linkNaviGrey};
          }
          :not(:disabled) {
            &:hover,
            &:active {
              outline: none;
              cursor: pointer;
              svg {
                fill: ${isLoggedIn
                  ? theme.colors.primaryBlueHover
                  : theme.colors.primaryBlue};
              }
            }
          }
        `}
        onClick={() => dispatch(setPopover(!showPopover))}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 13 13"
        >
          <path
            css={css`
              transition: fill 0.15s ease-in-out;
            `}
            d="M11.3 9.75c-1.87-.41-3.58-.81-2.77-2.36C11.05 2.6 9.18 0 6.5 0S2 2.68 4.47 7.39c.9 1.61-.89 1.95-2.76 2.36S.12 11 0 13h13c-.14-2 .17-2.76-1.7-3.25z"
          />
        </svg>
        <UpgradesBubble className="account-upgrades-bubble" />
      </button>
      {showPopover && <AccountMenu />}
    </span>
  );
};

export default AccountButton;
